<template>
  <div>
    <vs-card>
      <!-- Tabela -->
      <vs-table
        stripe
        search
        :data="listImportacoes"
        pagination
        max-items="15"
        v-model="selected"
        @selected="buscaLeads"
      >
        <template slot="header">
          <h3>Importações:</h3>
        </template>

        <template slot="thead">
          <vs-th class="background" sort-key="idImportacao">ID</vs-th>
          <vs-th class="background" sort-key="nomeConsultor">{{
            $t('Consultor')
          }}</vs-th>
          <vs-th class="background" sort-key="nomeRegional">{{
            $t('Regional')
          }}</vs-th>
          <vs-th class="background" sort-key="anoMesReferencia"
            >Ano/Mês de Referência</vs-th
          >
          <vs-th class="background" sort-key="createdAt">Data de Upload</vs-th>
          <vs-th class="background">Arquivo</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">
            <vs-td>{{ tr.idImportacao }}</vs-td>
            <vs-td>{{ tr.nomeConsultor }}</vs-td>
            <vs-td>{{ tr.nomeRegional }}</vs-td>
            <vs-td>{{ tr.anoMesReferencia }}</vs-td>
            <vs-td>{{ tr.dataUpload }}</vs-td>
            <vs-td><a :href="`${tr.arquivo}`">Link</a></vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-card>

    <!-- Modal -->
    <vs-popup title="Lista de Leads" :active.sync="popupAtivo" fullscreen>
      <div class="m-5" v-if="selected">
        <!-- Cabeçalho do modal -->
        <div class="m-5">
          <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
              <p class="font-bold">{{ $t('Consultor') }}:</p>
              {{ selected.nomeConsultor }}
            </div>
            <div class="vx-col w-1/2">
              <p class="font-bold">{{ $t('Regional') }}:</p>
              {{ selected.nomeRegional }}
            </div>
          </div>
          <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
              <p class="font-bold">Ano/Mês de Referência:</p>
              {{ selected.anoMesReferencia }}
            </div>
            <div class="vx-col w-1/2">
              <p class="font-bold">Data de Upload:</p>
              {{ selected.dataUpload }}
            </div>
          </div>
        </div>

        <!-- Tabela do modal -->
        <vs-table stripe search :data="listLeads" pagination max-items="15">
          <template slot="header">
            <h3>Leads:</h3>
          </template>

          <template slot="thead">
            <vs-th class="background" sort-key="idLead">ID</vs-th>
            <vs-th class="background" sort-key="nome">Nome</vs-th>
            <vs-th class="background" sort-key="email">Email</vs-th>
            <vs-th class="background" sort-key="celular">Celular</vs-th>
            <vs-th class="background" sort-key="origem">Origem</vs-th>
            <vs-th class="background" sort-key="placa">Placa</vs-th>
            <vs-th class="background" sort-key="cidade">Cidade</vs-th>
            <vs-th class="background" sort-key="estado">Estado</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">
              <vs-td>{{ tr.idLead }}</vs-td>
              <vs-td>{{ tr.nome }}</vs-td>
              <vs-td>{{ tr.email }}</vs-td>
              <vs-td>{{ tr.celular }}</vs-td>
              <vs-td>{{ tr.origem }}</vs-td>
              <vs-td>{{ tr.placa }}</vs-td>
              <vs-td>{{ tr.cidade }}</vs-td>
              <vs-td>{{ tr.estado }}</vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import leadsService from '../service/index';
import notify from '../../../../../utils/notify';
import functions from '../../../../../utils/functions';

export default {
  props: ['idUsuarioUpload', 'listImportacoes'],

  data() {
    return {
      selected: null,
      listLeads: [],
      popupAtivo: false,
    };
  },

  methods: {
    async buscaLeads(tr) {
      try {
        this.$vs.loading();
        this.popupAtivo = true;
        this.listLeads = await leadsService.getLeads({
          idImportacao: tr.idImportacao,
        });
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
  },
  mounted() {
    this.$i18n.locale = functions.setLocaleBasedOnCompany();
  },
};
</script>

<style scoped>
.background {
  background: #a0dde133;
}

.background2 {
  background: #ddfdff;
}

.tableStyle > tbody > tr:nth-child(odd) {
  background: rgba(211, 209, 209, 0.219);
}

.tableStyle > thead {
  position: sticky;
  top: 0;
}
</style>
